import { Controller } from '@hotwired/stimulus';

const STATUS_BADGE_CLASSES = {
  captured: 'bg-emerald-100 text-emerald-800',
  no_script: 'bg-slate-100 text-slate-600',
  pending: 'bg-amber-50 text-amber-800'
};

export default class extends Controller {
  static targets = ['url', 'noScript', 'noScriptButton', 'statusBadge', 'scriptId'];

  markNoScript() {
    this.noScriptTarget.value = '1';
    if (this.hasUrlTarget) this.urlTarget.value = '';
    if (this.hasNoScriptButtonTarget) this.noScriptButtonTarget.disabled = true;
    this.updateStatusBadge('no_script');
    if (this.hasScriptIdTarget) this.scriptIdTarget.hidden = true;
  }

  clearNoScript() {
    this.noScriptTarget.value = '0';
    if (this.hasNoScriptButtonTarget) this.noScriptButtonTarget.disabled = false;
  }

  updateStatusBadge(status) {
    if (!this.hasStatusBadgeTarget) return;

    const label = status.replaceAll('_', ' ');
    this.statusBadgeTarget.textContent = label;
    this.statusBadgeTarget.className = `inline-flex px-2 py-0.5 rounded text-xs font-medium ${STATUS_BADGE_CLASSES[status] || STATUS_BADGE_CLASSES.pending}`;
  }
}
